import useCategories from './useCategories';

const useDetailsForCategories = (ids: string[]) => {
    const { categories = [] } = useCategories(false);

    return categories.filter(item => ids.includes(item.id));
};

export default useDetailsForCategories;
